const markdown = `
### Why secret solidarity?
 
The most promising antidote to the [techno-feudalist coup](https://www.ted.com/talks/carole_cadwalladr_this_is_what_a_digital_coup_looks_like?language=en) is *planetary solidarity networks* of the 100s of Ms of humans who know a better future is possible.

But we must manifest those without creating a honey-pot to surveil and attack us with. 

Secret solidarity networks solve that. We each control our little (secret) corner , and combine securely with others we trust in order to operate at the necessary scales.

### How big is your solidarity network?
We each know who we have true solidarity with, but it's mostly in our heads. 

For this experiment, Solidifi helps make that digital, as the 150 people ([Dunbar's number](https://en.wikipedia.org/wiki/Dunbar%27s_number)) in your LinkedIn connections (see *Caveats* below) you trust and collaborate with the most. Call that your ***personal solidarity network (PSN)***. 

How can we measure the size of our collective solidarity networks without centralizing the data and creating a honey-pot for surveillance?

### Let's do a Census
You are invited to bootstrap your ***PSN***, local to you alone, and contribute it obfuscated into a census that doesn't centralize any of the personal data.

It requires a few minutes of your time, and will give us all a sense of our collective potential. Then we can brainstorm how to use the results in other ways besides counting.

### How?
Four simple steps, using LinkedIn data and your browser's localStorage at first. See [Caveats](#caveats) below.

Here are your simple steps:

* Bootstrap your PSN
	* 1. Download your connections from [LinkedIn's *Export your data*](https://www.linkedin.com/mypreferences/d/download-my-data)
	* 2. [Import to *localStorage*](/import_solid), which can only be accessed by you and Solidifi. The result is better than what you got from LinkedIn, because we add extra information if we have it, specifically how much each of your connections is inter-connected with the others.
* Curate your Dunbar's number of tightest connections
	* 3. View what you just imported. Click the *checkbox* net to those you have most solidarity with.
	* That is your ***PSN***, saved to *localStorage* for now. Again [Caveats](#caveats)
	* View, manage, and delete your data [here](/import_solid).

* Share your obfuscated ***PSN*** to the Census. 
	* 4. This will give our server a hashed version of the LinkedIn username of each connection in your ***PSN***.
	* Since it's hashed, noone can tell who you are connected with.
	* But it does allow us to count up the number of unique usernames over all Solidifi ***PSNs***

### Privacy and trust
These times are urgent, so we are starting this experiment with less than ideal cybersecurity. But we are not asking you to risk any valuable data. This just gets us started with seeing ourselves as large numbers without a central database.

For now, you need to trust Solidifi with the data in your localStorage. We will never send it anywhere else in any unobfuscated form, and we provide easy deletion mechanisms. 

Before long, this website will be open source and auditable so anyone can confirm that the above is true.

### Caveats
Yes, LinkedIn is a limited user community, but it's a great bootstrapping mechanism. They have 890M users, and we have mapped over 400K of those most closely connected to about 2000 'regen' people. So it's a useful first experiment.

And yes, *localStorage* is not completely secure. We will be moving to much more cryptographically secure methods, but time is of the essence so we're using this approach for now.

And yes, you can hack your own *localStorage* to create fake usernames that would be counted as real people. Please don't do that. You are here because someone invited you to participate, and that will reflect badly on them if discovered. We will be instituting countermeasures.



`;

export default markdown;
